import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

@Component({
  selector: 'app-requisition-backward-action-modal',
  templateUrl: './requisition-backward-action-modal.component.html'
})
export class RequisitionBackwardActionModalComponent implements OnInit {

  modalData: any;
  public onClose: Subject<any>;
  MESSAGECONSTANTS = MESSAGECONSTANTS;
  copyNote: any;
  disableSubmit = false;

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    const titleName = this.modalData.requisitionSPOC.titleName;
    this.disableSubmit = titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE ||
      titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE;
  }

  closeModal() {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

  onModifyRequisitionStates() {
    const requisitionSPOC = this.modalData.requisitionSPOC;
    this.bsModalRef.hide();
    this.modalData.modifyRequisitionStates(requisitionSPOC, 'Backward');
  }

  onInternalNoteChanged() {
    this.modalData.requisitionSPOC.externalNote = this.modalData.requisitionSPOC.note;
  }

  onExternalNoteChange(event) {
    this.modalData.requisitionSPOC.externalNote = event.externalNote;
  }

  onCopyNoteChange(event) {
    this.copyNote = event.copyNote;
  }

  receiveFormalizedComment(event) {
    this.modalData.requisitionSPOC.note = event;
  }

  onVoiceTranscript(transcript) {
    if (this.modalData.requisitionSPOC.note) {
      this.modalData.requisitionSPOC.note += ' ' + transcript;
    } else {
      this.modalData.requisitionSPOC.note = transcript;
    }
  }

  onCandidateChange() {
    const requisitionSPOC = this.modalData.requisitionSPOC;
    const isRemoveJoined = requisitionSPOC.titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE;
    if (requisitionSPOC.candidate.canNotRemoveJoin && isRemoveJoined) {
      this.disableSubmit = true;
      const title = 'Cannot undo join for the candidate';
      const message = `This candidate is currently filled in Req # <b>${requisitionSPOC.candidate.filledInRequisitionNumber}</b> ` +
        `with Title <b>${requisitionSPOC.candidate.filledInRequisitionTitle}</b> ` +
        `at <b>${requisitionSPOC.candidate.clientOrBuOfFilledOrJoinedRequisition}</b>. Please perform 'Undo Fill' action ` +
        `on the candidate for that Requisition before performing 'Undo Join' action in this Requisition.`;
      this.modalData.showAlert(title, message);
    } else {
      this.disableSubmit = false;
    }
  }

}
